export const USER_DATA = ({
	DEPOSIT: 'user_deposit',
	LEVERAGE: 'user_leverage',
	STOP_LOSS_PERCENT: 'user_stop_loss_percent',
});